import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import Auth from '../components/Auth';
import '../css/DocuCurso.css';

function DocuCurso() {
  const { wp_id } = useParams();
  const location = useLocation();
  const pedidos = location.state ? location.state.pedidos : []; // Obtiene los pedidos desde la página anterior
  const [documentacionAsignada, setDocumentacionAsignada] = useState([]);
  const [pedidosConDocumentacion, setPedidosConDocumentacion] = useState([]);
  const [docuid, setDocuid] = useState([]);
  const [mensajeGuardado, setMensajeGuardado] = useState(false);

console.log('pedidos',pedidos);


  console.log('pedidosConDocumentacion', pedidosConDocumentacion);


  useEffect(() => {
    asignarDocumentaciones();
  }, []);

  // Obtiene los IDs de la documentación asignada
  async function asignarDocumentaciones() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/curso/buscar/${wp_id}`
      );

      const cursoData = response.data.docu_id;
      await obtenerDocumentacion(cursoData);
    } catch (error) {
      console.error('Error al obtener el curso:', error);
    }
  }

  // Recibe los IDs de la documentación asignada, obtiene el listado de documentaciones lo pasa a number y lo almacena en docuid
  async function obtenerDocumentacion(docuIdsCurso) {
    try {

      if (typeof docuIdsCurso === 'string') {
        docuIdsCurso = docuIdsCurso.replace(/[\[\]\s]/g, '').split(',').map(id => Number(id.trim()));
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/docu/buscar`
      );
      const docu = response.data;
      let documentacion = {};
      let idsDocumentacion = [];

      docu.forEach((documento) => {
        if (docuIdsCurso.includes(Number(documento.id_docu))) {
          documentacion[documento.id_docu] = documento.documentacion;
          idsDocumentacion.push(documento.id_docu);
        }
      });
      setDocuid(idsDocumentacion);
      setDocumentacionAsignada(documentacion);
      obtenerGestionadas();
    } catch (error) {
      console.error('Error al obtener el curso y las documentaciones de los pedidos:', error);
    }
  }

  //obtiene los datos de documentaciones recibidas y validadas de los pedidos
  async function obtenerGestionadas() {
    try {
      const pedidosResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/pedido/buscar/${wp_id}`);
      const asignadasPedidos = pedidosResponse.data.pedidos;

console.log('asignadasPedidos',asignadasPedidos);

      await ponerValoresRecibidaYgestionadaEnPedidos(asignadasPedidos)
      } catch (error) {
      console.error('Error al obtener las documentaciones gestionadas:', error);
    }
  }

  // Añade las propiedades recibida y validada y sus datos en un aray en formato number a los pedidos correspondientes
  // async function ponerValoresRecibidaYgestionadaEnPedidos(asignadasPedidos) {
  //   const asignadasMap = {};
  //   asignadasPedidos.forEach(array => {
  //     array.forEach(asignada => {
  //       asignadasMap[asignada.numero_pedido] = {
  //         recibida: asignada.recibida ? asignada.recibida.split(',').map(Number) : [],
  //         validada: asignada.validada ? asignada.validada.split(',').map(Number) : []
  //       };
  //     });
  //   });

  //   const pedidosActualizados = pedidos.map(pedido => {
  //     const asignada = asignadasMap[pedido.numero_pedido] || {};
  //     return {
  //       ...pedido,
  //       recibida: asignada.recibida.length > 0 ? asignada.recibida : [],
  //       validada: asignada.validada.length > 0 ? asignada.validada : []
  //     };
  //   });

  //   setPedidosConDocumentacion(pedidosActualizados);

  //   console.log('setPedidosConDocumentacion',setPedidosConDocumentacion);
    
  //   descargarDocumentacionSUbidaPorCliente(wp_id)
  // }







  async function ponerValoresRecibidaYgestionadaEnPedidos(asignadasPedidos) {
    const asignadasMap = {};
    asignadasPedidos.forEach(array => {
        array.forEach(asignada => {
            asignadasMap[asignada.numero_pedido] = {
                recibida: asignada.recibida ? asignada.recibida.split(',').map(Number) : null,
                validada: asignada.validada ? asignada.validada.split(',').map(Number) : null
            };
        });
    });

    const pedidosActualizados = pedidos.map(pedido => {
        const asignada = asignadasMap[pedido.numero_pedido] || {};
        return {
            ...pedido,
            recibida: asignada.recibida !== null ? asignada.recibida : pedido.recibida,
            validada: asignada.validada !== null ? asignada.validada : pedido.validada
        };
    });

    setPedidosConDocumentacion(pedidosActualizados);
    console.log('pedidosActualizados', pedidosActualizados);
    descargarDocumentacionSUbidaPorCliente(wp_id);
}




   // descarga la documentación que subio el cliente desde su página
   async function descargarDocumentacionSUbidaPorCliente(wp_id) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/docuwp/buscar/${wp_id}`
      );
      const clienteDocu = response.data;
      console.log('clienteDocu', clienteDocu);


      setPedidosConDocumentacion(prevPedidos =>
        prevPedidos.map(pedido => {
          const docuCliente = clienteDocu.contenido
            .filter(doc => parseInt(doc.pedido) === pedido.numero_pedido)
            .flatMap(doc => doc.documentacion)
            .map(doc => doc.nombre);
      
          return {
            ...pedido,
            documentacionCliente: docuCliente.length > 0 ? docuCliente : [],
          };
        }));

    } catch (error) {
      console.error('Error al obtener la documentación del cliente', error);
    }
  }

  // crea el enlace de descarga para la documentación subida por el cliente
  async function descargarDocuCliente(numero_pedido, wp_id, docName) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/cliente/Docuclientes/${wp_id}/${numero_pedido}/${docName}`,
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', docName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar el documento:', error);
    }
  }

  //muestra la fecha con el formato correcto
  const formatoFecha = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  //gestiona el marcado y desmarcado de los checkbox
  const manejarCheckbox = (id, tipo, numero_pedido) => {
    const updatedPedidos = pedidosConDocumentacion.map(pedido => {
      const recibida = Array.isArray(pedido.recibida) ? pedido.recibida : [];
      const validada = Array.isArray(pedido.validada) ? pedido.validada : [];

      if (pedido.numero_pedido === numero_pedido) {
        const updatedRecibida = tipo === 'recibida'
          ? recibida.includes(id)
            ? recibida.filter(docId => docId !== id) // Desmarcar
            : [...recibida, id] // Marcar
          : recibida;

        const updatedValidada = tipo === 'validada'
          ? validada.includes(id)
            ? validada.filter(docId => docId !== id) // Desmarcar
            : [...validada, id] // Marcar
          : validada;

        return {
          ...pedido,
          recibida: updatedRecibida,
          validada: updatedValidada,
        };
      }
      return pedido;
    });

    setPedidosConDocumentacion(updatedPedidos);
  };


  async function guardarDatos(numero_pedido, recibida, validada) {
    try {
      const recibidaString = Array.isArray(recibida) ? recibida.join(',') : recibida;
      const validadaString = Array.isArray(validada) ? validada.join(',') : validada;

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/pedido/editar`,
        {
          numero_curso: wp_id,
          numero_pedido: numero_pedido,
          asignada: docuid.join(','),
          recibida: recibidaString,
          validada: validadaString
        }
      );

      cambiosGuardados();
    } catch (error) {
      console.error('Error al guardar los cambios:', error);
    }
  }

  //muestra el mensaje de datos guardados durante el tiempo que se le indique
  function cambiosGuardados() {
    setMensajeGuardado(true);
    setTimeout(() => {
      setMensajeGuardado(false)
    }, 2000);
  }

  //cambia el estado del pedido a completado en wordpress
  const completarPedido = async (idWpPedido) => {
    const confirmar = window.confirm(
      `Estás a punto de completar el pedido con ID: ${idWpPedido}. ¿Quieres continuar?`
    );

    if (confirmar) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/pedido/estado/${idWpPedido}`,
          { status: 'completed' }
        );

        if (response.data.message && response.data.message.includes('completado exitosamente')) {
          alert(`El pedido ${idWpPedido} se ha completado exitosamente.`);

          await eliminarPedidoWp(idWpPedido);
          window.location.href = '/gestion';

        } else {
          alert(`No se pudo completar el pedido ${idWpPedido}.`);
        }
      } catch (error) {
        console.error('Error al completar el pedido:', error);
        alert(`Hubo un error al completar el pedido ${idWpPedido}.`);
      }
    } else {
      alert('Acción cancelada.');
    }
  };

  //cuando se completa el pedido lo elimina el pedido de la base de datos de la app
  const eliminarPedidoWp = async (idWpPedido) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/pedidowp/borrar/${idWpPedido}`
      );

      if (response.status === 200) {
        console.log(`Pedido ${idWpPedido} eliminado correctamente.`);
      } else {
        console.error(`No se pudo eliminar el pedido ${idWpPedido}.`);
      }
    } catch (error) {
      console.error('Error al eliminar el pedido en WordPress:', error);
    }
  };

  return (
    <Auth>
      {({ nombreUsuario, isAdmin, handleLogout }) => (
        <div className='curso_detalle_container'>
          <h2>Bienvenido, {nombreUsuario}</h2>
          <button onClick={handleLogout}>Cerrar sesión</button>
          <p>Número de pedidos: {pedidosConDocumentacion.length}</p>
          <h2>Detalle de los pedidos realizados del curso</h2>
          {pedidosConDocumentacion.length === 0 ? (
            <p>No hay pedidos disponibles.</p>
          ) : (
            <ul>
              {pedidosConDocumentacion.map(pedido => (
                <li key={pedido.id} className='order_item'>
                  <div className='order_info'>
                    <p>
                      Pedido: {pedido.numero_pedido} - Estado: {pedido.estado}<br />
                      Producto: {pedido.nombre_producto}<br />
                      Fecha del pedido: {formatoFecha(pedido.fecha_pedido)} - Cliente: {pedido.nombre_cliente}<br />
                      Id del cliente: {pedido.cliente_id}
                    </p>
                    <div className='documentacion_section'>
                      <p>Documentación Necesaria:</p>
                      {Object.entries(documentacionAsignada).map(([id, nombreDoc]) => (
                        <label key={id} className='documentacion_item'>
                          {nombreDoc}
                          <div className='checkbox_section'>
                            <input
                              type='checkbox'
                              id={`documentacion_${id}_recibida`}
                              name={`documentacion_${id}_recibida`}
                              checked={Array.isArray(pedido.recibida) && pedido.recibida.includes(Number(id))}
                              onChange={() => manejarCheckbox(Number(id), 'recibida', pedido.numero_pedido)}
                            />
                            Recibida
                            <input
                              type='checkbox'
                              id={`documentacion_${id}_validada`}
                              name={`documentacion_${id}_validada`}
                              checked={Array.isArray(pedido.validada) && pedido.validada.includes(Number(id))}
                              onChange={() => manejarCheckbox(Number(id), 'validada', pedido.numero_pedido)}
                            />
                            Validada
                            <button className='boton_subir'
                              onClick={() => {
                                window.open('/alfresco', '_blank');
                              }}
                            >
                              Subir
                            </button>
                          </div>
                        </label>
                      ))}
                    </div>
                    <div className='divGuardar'>
                      <button className='botonGuardar'
                        onClick={() => guardarDatos(pedido.numero_pedido, pedido.recibida, pedido.validada)}
                      >
                        Guardar
                      </button>
                      <button onClick={() => completarPedido(pedido.numero_pedido)}>
                        Completar pedido
                      </button>
                      {mensajeGuardado && (
                        <div className="mensajeGuardado">
                          <p>Cambios guardados correctamente.</p>
                        </div>
                      )}
                    </div>
                    <div className='documentacion_cliente'>
                      <p>Documentación del Cliente:</p>
                      {pedido.documentacionCliente && pedido.documentacionCliente.map((docName, index) => (
                        <div key={index}>
                          <p>
                            <a
                              href="#"
                              onClick={() => descargarDocuCliente(pedido.numero_pedido, wp_id, docName)} 
                            >
                              Descargar {docName}
                            </a>
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </Auth>
  );
}

export default DocuCurso;